import http from "../../utils/http";

// 담당회사 및 직원 변경
export const modifyAdminCompainesMyManagers = (companyIdx, body) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/companies/${companyIdx}/managers`, body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 담당회사 및 직원조회
export const getAdminCompainesMyManagers = (companyIdx) => {
  return new Promise((resolve, reject) => {
    http
      .get(`/companies/${companyIdx}/managers`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getManagerPermissions = () => {
  return new Promise((resolve, reject) => {
    http
      .get(`/employees/managerRole`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}